import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'admin-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  standalone: true,
})
export class BaseComponent<T> {
  data: T;
}
